export const LOGIN_ROUTE = 'login';
export const SIGN_UP_ROUTE = 'signup';
export const USER_ROUTE = 'user';
export const HOME_ROUTE = 'home';
export const NEWS_ROUTE = 'news';
export const POLLUTION_ROUTE = 'pollution';
export const FAQ_ROUTE = 'faq';